import L from 'leaflet';
import PropTypes from 'prop-types';
import { withLeaflet, MapControl } from 'react-leaflet';

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".leaflet-container.crosshair-cursor-enabled {cursor:crosshair;}";
styleInject(css);

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var reactToCSS = require('react-style-object-to-css');

var boxZoomControlDefaultStyle = {
  width: '32px',
  height: '32px',
  marginRight: '11px',
  border: '1px solid rgba(0,0,0,0.5)',
  borderRadius: '4px',
  background: 'url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAB60lEQVRIie3VPWtUQRTG8d9GjQaJLopiFDVC7LSzESWIhYiCKFiIlZWFRbCxEPwINhY2AUX8APEbCDZiExLsBFEjKeIL+AYiUXct7lyYvd65mZVoBH1gmOGcPfM/M+fcWf5lPUA3Gm+wM/iuohPsizgV7OP4XIm7mQMbiNbjFd8GrAvrLWiF9Rq0w7qNoUrcoRxwrDLjwxjFpkqCu4J9eyVuW7BfDPGzObDVNbZ5vKjYOniZ2GMhzK9zgKXiq36lqN/HfjaoxPedAIxgzy9CS+1T9Mbfq1a0vqZolAlFTZu0GacVHbxVUZ5ZTOFpv0mU3+nuJRK9jPd6v91yfMMk1vcDLoNHG6C3EsDqmMHGXPCXEDSS8E9kQssxlQs+hnMJX1v6em80wI/kwlO60LC5Bt+d1IbxA9J04oMJ+6cwv42SyInrUVON7+k9yWRij/OV373LATd19W31V/khSrpT43+egg3U2M4qano8ss0k4ofDPKj3MSo1nQLHqjvRgeDbofgDqfo7uKT+tF2cScFWReshfMdcGNOKB2NR0UTDfv6Tb+Gk+tM+wpUlj5uhQdyX/4AcXQ5oqbWKjk5dbRdfwzyPseWEw35cx0M8w2PcxQnsDdDfBm/SWARfCImuCHzuT4JL+BNFSf5rZfQD0s7CMRfyzDcAAAAASUVORK5CYII=")',
  backgroundColor: 'rgb(255, 255, 255)',
  outline: 'none'
};
var boxZoomControlDefaultActiveStyle = {
  backgroundColor: '#a3a3a3'
};
L.Control.BoxZoomControl = L.Control.extend({
  _style: null,
  _activeStyle: null,
  _isActive: false,
  _startLatLng: null,
  _sticky: false,
  _drawPolygon: null,
  _boxZoomButton: null,
  initialize: function initialize(element) {
    this.options.position = element.position;

    if (element.style === undefined) {
      this._style = reactToCSS(boxZoomControlDefaultStyle);
    } else {
      this._style = reactToCSS(element.style);
    }

    if (element.activeStyle === undefined) {
      this._activeStyle = reactToCSS(boxZoomControlDefaultActiveStyle);
    } else {
      this._activeStyle = reactToCSS(element.activeStyle);
    }

    if (element.sticky !== undefined) {
      this._sticky = element.sticky;
    }
  },
  onAdd: function onAdd(map) {
    var _this = this;

    var boxZoomButton = L.DomUtil.create('button');
    boxZoomButton.setAttribute('style', this._style);
    boxZoomButton.setAttribute('id', 'box-zoom-button');

    boxZoomButton.onclick = function (e) {
      if (_this._isActive) {
        _this._stop(map, boxZoomButton);
      } else {
        _this._start(map, boxZoomButton);
      }
    };

    this._boxZoomButton = boxZoomButton;
    return boxZoomButton;
  },
  onRemove: function onRemove(map) {// Do nothing
  },
  _stop: function _stop(map, boxZoomButton) {
    map.dragging.enable();
    boxZoomButton.setAttribute('style', this._style);
    L.DomUtil.removeClass(map._container, 'crosshair-cursor-enabled');
    this._isActive = false;
    this._startLatLng = null;
    L.DomEvent.off(map, 'mousemove', this._handleMouseMove, this);
    L.DomEvent.off(map, 'mouseup', this._handleMouseUp, this);
  },
  _handleMouseDown: function _handleMouseDown(e) {
    this._startLatLng = e.latlng;
  },
  _handleMouseMove: function _handleMouseMove(e) {
    if (this._startLatLng === null || this._startLatLng === undefined) {
      return;
    }

    var ne = this._startLatLng;
    var nw = new L.LatLng(this._startLatLng.lat, e.latlng.lng);
    var sw = e.latlng;
    var se = new L.LatLng(e.latlng.lat, this._startLatLng.lng);

    if (this._drawPolygon === null || this._drawPolygon === undefined) {
      this._drawPolygon = new L.Polygon([ne, nw, sw, se]);

      this._map.addLayer(this._drawPolygon);
    } else {
      this._drawPolygon.setLatLngs([ne, nw, sw, se]);
    }
  },
  _handleMouseUp: function _handleMouseUp(e) {
    var map = this._map;

    if (this._startLatLng === null || this._startLatLng === undefined || this._startLatLng.lat === e.latlng.lat || this._startLatLng.lng === e.latlng.lng || this._isActive === false) {
      return;
    }

    var ne = this._startLatLng;
    var nw = new L.LatLng(this._startLatLng.lat, e.latlng.lng);
    var sw = e.latlng;
    var se = new L.LatLng(e.latlng.lat, this._startLatLng.lng);
    var bounds = L.latLngBounds([ne, sw]);
    map.fitBounds(bounds, {
      animate: false
    });
    this._startLatLng = null;
    map.removeLayer(this._drawPolygon);
    this._drawPolygon = null;

    if (this._sticky) {
      this._startLatLng = null;
    } else {
      map.dragging.enable();

      this._boxZoomButton.setAttribute('style', this._style);

      L.DomUtil.removeClass(map._container, 'crosshair-cursor-enabled');
      this._isActive = false;
      L.DomEvent.off(map, 'mousemove', this._handleMouseMove, this);
      L.DomEvent.off(map, 'mouseup', this._handleMouseUp, this);
    }
  },
  _start: function _start(map, boxZoomButton) {
    boxZoomButton.setAttribute('style', this._style + this._activeStyle);
    map.dragging.disable();
    L.DomUtil.addClass(map._container, 'crosshair-cursor-enabled');
    this._isActive = true;
    this._startLatLng = null;
    L.DomEvent.on(map, 'mousedown', this._handleMouseDown, this);
    L.DomEvent.on(map, 'mousemove', this._handleMouseMove, this);
    L.DomEvent.on(map, 'mouseup', this._handleMouseUp, this);
  },
  forceStop: function forceStop() {
    var map = this._map;
    var boxZoomButton = L.DomUtil.get('box-zoom-button');

    this._stop(map, boxZoomButton);
  },
  forceStart: function forceStart() {
    var map = this._map;
    var boxZoomButton = L.DomUtil.get('box-zoom-button');

    this._start(map, boxZoomButton);
  }
});

L.control.boxZoomControl = function (opts) {
  return new L.Control.BoxZoomControl(_extends({}, opts));
};

var BoxZoomControl = function (_MapControl) {
  inherits(BoxZoomControl, _MapControl);

  function BoxZoomControl(props) {
    classCallCheck(this, BoxZoomControl);
    return possibleConstructorReturn(this, (BoxZoomControl.__proto__ || Object.getPrototypeOf(BoxZoomControl)).call(this, props));
  }

  createClass(BoxZoomControl, [{
    key: 'createLeafletElement',
    value: function createLeafletElement(props) {
      this.control = L.control.boxZoomControl(_extends({}, props));
      return this.control;
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.control.forceStop();
    }
  }, {
    key: 'start',
    value: function start() {
      this.control.forceStart();
    }
  }]);
  return BoxZoomControl;
}(MapControl);

var leafletBoxZoomControl = withLeaflet(BoxZoomControl);
BoxZoomControl.propTypes = {
  sticky: PropTypes.bool,
  style: PropTypes.element,
  activeStyle: PropTypes.element,
  position: PropTypes.oneOf(['topright', 'topleft', 'bottomright', 'bottomleft'])
};
export { leafletBoxZoomControl as BoxZoomControl };